import { createJobProcess } from "@/api/query/jobProcess";
import { findAllLanguages } from "@/api/query/language";
import Loading from "@/common/components/Loading";
import PopUp from "@/common/components/PopUp";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { MessageContext } from "@/common/contexts/message.context";
import React, { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { ButtonWrapper, Title } from "../../AdminCommandPage.styled";
import { JOB_NAME } from "../../constants/jobs";

const TextToSpeechScript = ({ setClose, reloadMutation }) => {
  const [languagesOptions, setLanguagesOptions] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const { addMessage } = useContext(MessageContext);

  const loadLanguagesMutation = useMutation({
    mutationFn: () => findAllLanguages(),
    onSuccess: ({ data }) => {
      setLanguagesOptions(() => data.map((d) => ({ label: d.name, value: d })));
    },
  });

  const createJobProcessMutation = useMutation({
    mutationFn: (values) => createJobProcess(values),
    onSuccess: () => {
      addMessage("Added job", "success");
      setClose((prev) => !prev);
      reloadMutation.mutate();
    },
    onError: () => {
      addMessage("Something went wrong", "error");
    },
  });

  const handleCreateJobProcess = () => {
    if (!selectedLanguages?.length) return;

    const jobName = JOB_NAME.TEXT_TO_SPEECH_SCRIPT;
    const argumentsPassed = {
      languagesShorts: selectedLanguages.map((lang) => lang.value.shortName),
    };

    const payload = {};

    payload.job_name = jobName;
    payload.arguments_passed = JSON.stringify(argumentsPassed);

    createJobProcessMutation.mutate(payload);
  };

  useEffect(() => {
    loadLanguagesMutation.mutate();
  }, []);

  return (
    <>
      {createJobProcessMutation.isLoading && <Loading />}
      <PopUp setClose={setClose}>
        <Title>Select desired languages</Title>
        <SelectInput
          width={120}
          selectWidth={400}
          multiple
          name={"Language to"}
          options={languagesOptions}
          selected={selectedLanguages}
          setSelected={setSelectedLanguages}
        />
        <ButtonWrapper>
          <CustomEditButton
            text="Convert text to speech"
            onClick={() => handleCreateJobProcess()}
          />
        </ButtonWrapper>
      </PopUp>
    </>
  );
};

export default TextToSpeechScript;
